import { ErrorHandler, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular/lazy';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { LoginModule } from '@app/pages/login/login.module';
import { LayoutModule } from '@app/layout/layout.module';
import { SmartMovingSharedLibModule } from '@smartmoving/sm-shared-lib';
import { environment } from 'src/environments/environment';
import { AuthorizationHttpInterceptor } from '@app/core/authorization-http.interceptor';
import { CoreModule } from '@app/core/core.module';
import { NgDynamicBreadcrumbModule } from 'ng-dynamic-breadcrumb';
import { BreadcrumbComponent } from '@app/style-guide/breadcrumb/breadcrumb.component';
import { GlobalErrorHandlerService } from '@app/core/logging/global-error-handler.service';
import { DirtySyncModalComponent } from '@app/components/dirty-sync-modal/dirty-sync-modal.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  declarations: [AppComponent, BreadcrumbComponent, DirtySyncModalComponent],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    IonicModule.forRoot({
      rippleEffect: false,
      mode: 'ios',
    }),
    FormsModule,
    AppRoutingModule,
    LoginModule,
    LayoutModule,
    HttpClientModule,
    CoreModule,
    NgDynamicBreadcrumbModule,
    SmartMovingSharedLibModule.forRoot(environment),
    SimpleNotificationsModule.forRoot({
      position: ['top', 'right'],
      timeOut: 3000,
      showProgressBar: false,
      pauseOnHover: true,
      clickToClose: true
    }),
    SharedModule,
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: AuthorizationHttpInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
